import React, {useState} from 'react';
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import {useForm} from "react-hook-form";
import {connect, useSelector} from "react-redux";

// labels

// actions

// components
import { ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";
import Switch from "react-bootstrap-switch";
import {getStateByPath} from "../../../redux/selectors";
import {setFilter} from "../../../redux/actions/generics/IndexedActions";


function RoleFilters(props) {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter } = componentState?.data || {};

    const [isSupervisor, setIsSupervisor] = useState(null);

    const cleanFields = () => {
        setIsSupervisor(null);
        reset();
    }

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {register, handleSubmit, reset} = useForm({
    });

    const onSubmit = (data, _) => {
        let _filter = {
            ...data,
            isAdmin : isSupervisor,
        }

        props.setFilter(path, _filter);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>Rol</Label>
                            <Input
                                type="text"
                                name="authority"
                                placeholder="Rol"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{'Es admin'}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                innerRef={register}
                                onChange={()=> setIsSupervisor(!isSupervisor)}
                                value={isSupervisor}
                            />
                        </FormGroup>
                    </Col>


                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <ButtonSearch />
                        <ButtonClean onClick={() => cleanFields()} />
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = _ => ({
})

const mapActionsToProps = ({
    setFilter
})

export default connect(mapStateToProps, mapActionsToProps)(RoleFilters)